<div class="guts-p-full-1-half">
  <div [class.open]="isSearchOpen">
    <dgx-search-field-wrapper class="block guts-m-b-1">
      <input
        type="text"
        [formControl]="searchControl"
        [placeholder]="searchCatalogText"
        (click)="openSearch()"
        (focus)="openSearch()"
        autocomplete="off"
        aria-haspopup="true"
        aria-owns="searchCatalog"
        [attr.aria-expanded]="isSearchOpen"
        [attr.aria-label]="searchCatalogText"
        data-dgat="searchCatalog-3ed"
      />
    </dgx-search-field-wrapper>

    <div
      class="
        guts-m-t-0
        dropdown-menu
        rounded--large
        dropdown-menu__min-height--with-header
        no-border no-shadow
      "
      style="position: relative !important"
      id="searchCatalog"
      [hidden]="!isSearchOpen"
    >
      <div class="guts-p-b-1">
        <dgx-search-filters
          [isLoading]="isSearching"
          [isClientProvider]="isClientProvider"
          [organizationName]="orgName"
          [numberOfSkeletonColumns]="5"
          [usesGlobalSearchApi]="true"
          [filters]="searchFilters"
          (filtersChange)="applyFilters($event)"
        ></dgx-search-filters>
      </div>

      <div
        *ngIf="searchTotal != undefined && !isSearching"
        class="guts-m-t-1 par par--small par--light_a font-bold"
      >
        <ng-container *ngIf="searchTotal === 1; else searchTotalPlural">{{
          'LearningSearch_ResultsCount_SingleFormat'
            | translate: { count: searchTotal }
        }}</ng-container>
        <ng-template #searchTotalPlural>{{
          'LearningSearch_ResultsCount_PluralFormat'
            | translate: { count: searchTotal }
        }}</ng-template>
      </div>

      <div class="guts-p-v-0 guts-m-v-1 rel typeahead-list scrollable">
        <ul *ngIf="!isSearching">
          <li
            *ngFor="let item of searchResults; let i = index"
            data-dgat="searchCatalog-1d9"
          >
            <button
              (click)="addToSavedList(item, i)"
              class="typeahead-item__hoverable full-width left-text"
              data-dgat="searchCatalog-b07"
            >
              <dgx-resource-result
                [item]="item"
                [endorsedSrc]="item.isEndorsed ? endorsedSrc : ''"
              ></dgx-resource-result>
            </button>
          </li>
        </ul>
        <div *ngIf="isSearching">
          <div>
            <dgx-skeleton type="list" [rows]="5"></dgx-skeleton>
          </div>
        </div>
        <dgx-no-search-results
          *ngIf="!searchResults.length && !isSearching && searchTerm"
        ></dgx-no-search-results>
      </div>
    </div>
  </div>

  <div
    *ngIf="savedItems.length"
    [ngClass]="isSearchOpen ? 'guts-m-t-2 border-top' : ''"
  >
    <dgx-org-managed-notification
      *ngIf="showOrgManagedNotification"
      class="block guts-m-t-1"
      [isCombinedSearch]="true"
      [resourceType]="resourceType"
    ></dgx-org-managed-notification>
    <h2 class="h4 par--light guts-m-t-1 guts-p-b-half">
      {{ selectedText }}
    </h2>
    <div
      *ngFor="let saved of savedItems"
      data-dgat="addManually-f90"
      class="border-bottom not-last"
    >
      <dgx-resource-result
        [item]="saved"
        (remove)="removeFromSavedList($event)"
      ></dgx-resource-result>
    </div>
  </div>
</div>
<dgx-modal-footer
  [canCancel]="true"
  [useDefaultSubmitButton]="false"
  (dismiss)="dismiss.emit($event)"
>
  <button
    *ngIf="showHoldForLater"
    df-button
    dfButtonType="passive"
    type="button"
    (click)="onHoldForLater()"
    class="guts-m-r-1"
    [disabled]="!savedItems.length"
    data-dgat="searchCatalog-89b"
  >
    {{ holdForLaterText }}
  </button>
  <button
    df-button
    dfButtonType="primary"
    type="button"
    (click)="onAddItems()"
    [disabled]="!savedItems.length"
    data-dgat="searchCatalog-cc4"
  >
    <df-spinner-button [isSpinning]="isSubmitting">
      {{ addItemsButtonText }}
    </df-spinner-button>
  </button>
</dgx-modal-footer>
